// features/intelligence/tabs/community.js
// ═══════════════════════════════════════════════════════════
// COMMUNITY — signals + intelligence from other practitioners
// using Shift in the same domain. Source nominations, pattern
// observations, credibility-scored contributions.
//
// Lowest-priority tab per the spec — the product is fully
// functional without it. Layer 1 here is intentionally light:
// shows shape only.
// ═══════════════════════════════════════════════════════════

import { TRADING_DOMAIN } from '../../../lib/intelligence/sample-trading-domain';

const TYPE_LABEL = {
  disc: 'Discussion',
  art:  'Field Article',
  qa:   'Q&A',
};

export default function CommunityTab() {
  const rows = TRADING_DOMAIN.community.rows;
  return (
    <div className="di-scroll">
      <div className="di-section" style={{ marginBottom: 16 }}>
        <div className="di-sec-header">
          <div className="di-sec-label">Community Pulse — Trading</div>
          <div className="di-sec-right">
            <div className="di-sec-live">● {TRADING_DOMAIN.community.activeCount} active</div>
            <div className="di-sec-time">View all →</div>
          </div>
        </div>
        {rows.map((row, ri) => (
          <div key={ri} className="di-community-grid" style={{ borderTop: ri > 0 ? '1px solid #1e1e2a' : 'none' }}>
            {row.map((c, ci) => (
              <div key={ci} className="di-ci">
                <div className={`di-ci-type ${c.kind}`}>{TYPE_LABEL[c.kind]}</div>
                <div className="di-ci-text" dangerouslySetInnerHTML={{ __html: c.text }} />
                <div className="di-ci-meta">{c.meta}</div>
              </div>
            ))}
          </div>
        ))}
      </div>

      <div className="di-placeholder" style={{ height: 'auto', padding: '40px 20px' }}>
        <div className="di-eyebrow-tag">Coming next</div>
        <h2>Source nominations + credibility scoring</h2>
        <p>
          Other practitioners flag sources worth adding to the default set. Pattern
          observations from the community pool. Credibility scoring that weights
          who you trust by their track record. Community is the lowest-priority
          tab — built last, after the rest of the product is solid.
        </p>
      </div>
    </div>
  );
}
